import { initializeApp } from "firebase/app";
import { isSupported, getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAFlHebihjr91-OYzZ03Q_3Jzj2zITJpMc",
  authDomain: "language-of-thoughts.firebaseapp.com",
  projectId: "language-of-thoughts",
  storageBucket: "language-of-thoughts.firebasestorage.app",
  messagingSenderId: "399226207804",
  appId: "1:399226207804:web:093b3276c39d5617edcd39",
  measurementId: "G-MMZC3R36MV",
};

let app: ReturnType<typeof initializeApp>;
let auth: ReturnType<typeof getAuth>;
let db: ReturnType<typeof getFirestore>;
let storage: ReturnType<typeof getStorage>;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
} catch (error) {
  // Firebase is load-bearing for the entire app — without it nothing can
  // render meaningfully. Rethrow so this surfaces as an uncaught error the
  // boot watchdog in index.html can catch, instead of leaving `auth`/`db`
  // undefined and failing confusingly wherever they're first used.
  console.error("[LOT] Firebase failed to initialize", error);
  throw error;
}

isSupported()
  .then((supported) => {
    if (supported) getAnalytics(app);
  })
  .catch(() => {/* no-op */});

export { app, auth, db, storage };
